<template>
  <div>
    <profile-desktop v-if="screenType === 'desktop'"></profile-desktop>
    <profile-mobile v-else></profile-mobile>
  </div>
</template>

<script>
import ProfileMobile from "@/components/Pages/Mobile/Dashboard/ProfileMobile";
import ProfileDesktop from "@/components/Pages/Desktop/Dashboard/ProfileDesktop";

export default {
  name: "ProfileMain",
  components: {ProfileDesktop, ProfileMobile},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>